export * from './info-page-dialog.component';
